<template>
  <div>
    <div class="flex w-full flex-wrap gap-x-2 gap-y-2.5">
      <FormTagPill
        v-for="tag in tags"
        :key="tag"
        :name="tag"
        @click="update(tag)"
        :is-at-max="modelValue.length >= max"
        :checked="modelValue.indexOf(tag) !== -1"
      />
    </div>
    <InfiniteScrollTrigger @trigger="handleGetMoreResults" />
  </div>
</template>

<script setup>
import FormTagPill from "./FormTagPill.vue";
import InfiniteScrollTrigger from "./InfiniteScrollTrigger.vue";

const props = defineProps({
  tags: {
    type: Array,
    default: () => [],
  },
  modelValue: {
    type: Array,
    default: () => [],
  },
  max: Number,
});

const emits = defineEmits(["update:modelValue", "load-next-page"]);

const update = (tag) => {
  if (props.modelValue.indexOf(tag) !== -1) {
    emits("update:modelValue", props.modelValue.filter((t) => t !== tag));
    return;
  }

  if (props.max && props.modelValue.length >= props.max) {
    toast.info(`You can only select up to ${props.max} items`);
    return;
  }

  emits("update:modelValue", [...props.modelValue, tag]);
};

const handleGetMoreResults = () => {
  if(props.tags.length) emits("load-next-page");
};
</script>
